/** Tenants live at <slug>.<base domain>; the apex serves signup. The edge names the base
 *  domain when the page loads (/runtime-config.js), so one build serves every environment;
 *  in development it is the build's VITE_BASE_DOMAIN. */
const base =
  (globalThis as { CLIENTOS_BASE_DOMAIN?: string }).CLIENTOS_BASE_DOMAIN ??
  (import.meta.env.VITE_BASE_DOMAIN as string | undefined) ??
  "localhost";

export function tenantUrl(slug: string, path = "/"): string {
  const { protocol, port } = window.location;
  return `${protocol}//${slug}.${base}${port ? ":" + port : ""}${path}`;
}

export function apexUrl(path = "/"): string {
  const { protocol, port } = window.location;
  return `${protocol}//${base}${port ? ":" + port : ""}${path}`;
}

/** The apex domain serves signup and the workspace finder instead of a tenant; any other
 *  address is a workspace's, its own domain included. */
export function isApex(): boolean {
  const host = window.location.hostname.toLowerCase();
  return host === base || host === "www." + base;
}
